import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesToolsCustDetails from '@/employee/enquiries/customerDetails/enquiriesToolsCustDetails';

enum CustomerAccountStatus {
  Active = 0,
  Closed = 1,
}

enum AccountType {
  SingleAccount = 0,
  SubAccount = 1,
  GroupAccount = 2,
}

enum CustomerGender {
  None = 0,
  Male = 1,
  Female = 2,
}

export default {
  name: 'AttchImgOpDetChangesStatements',
    components: {
      DataGridComp: require('@/customcontrols/datagrid.vue').default,
      AttachmentsComp: require('@/employee/enquiries/customerAttachements.vue').default,
      ImagesComp: require('@/employee/enquiries/customerImages.vue').default,
      LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
      EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users, enquiriesToolsCustDetails],
  data: function () {
    return {
      menuVisible: true, 
      lang: '',
      pagesLoaded: ['attachments', 'images', 'operations', 'detailchanges', 'statements'],

      operations: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
      detailchanges: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
      statements: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "",
        isLoading: true,
      },
    }
  },
  created() {
    this.selectedTab = 'ownedProperties';
    this.fillGridColumns();
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
  },
  mounted() {
    this.menuVisible = this.getFromLocal('_enquries_cust_det');
  },
  computed: {
    isLoading: function () {
      return this.operations.isLoading || this.detailchanges.isLoading || this.statements.isLoading;
    },
    isRtl: function () {
      return this.lang == 'ar' ? true : false
    },
    selectedTabObj: function() {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    },
    empName: function () {
      return this.customerDisplayInfo && this.customerDisplayInfo.stampUser ? this.customerDisplayInfo.stampUser : null;
    }
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        case 'history':
        default:
         this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    },
  },
  methods: {
    init() {
      this.fillGridColumns();
      this.getData();
    },
    getData() {
      this.fillOperations();
      this.fillDetailsChanges();
      this.fillStatements();
    },

    fillGridColumns() {
      this.operations.cols.length = 0;
      this.detailchanges.cols.length = 0;
      this.statements.cols.length = 0;

      this.operations.cols.push({ dataField: 'operation', caption: this.$t('enquiriesCustomerDetails.operation') });
      this.operations.cols.push({ dataField: 'description', caption: this.$t('enquiriesCustomerDetails.description') });
      this.operations.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.operations.cols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });

      this.detailchanges.cols.push({ dataField: 'field', caption: this.$t('enquiriesCustomerDetails.property') });
      this.detailchanges.cols.push({ dataField: 'originalValue', caption: this.$t('enquiriesCustomerDetails.originalValue') });
      this.detailchanges.cols.push({ dataField: 'newValue', caption: this.$t('enquiriesCustomerDetails.newValue') });
      this.detailchanges.cols.push({ dataField: 'sourceId', caption: this.$t('enquiriesCustomerDetails.applicationNo') });
      this.detailchanges.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.detailchanges.cols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesCustomerDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });

      this.statements.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesCustomerDetails.custkey') });
      this.statements.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesCustomerDetails.accountName') });
      this.statements.cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.statements.cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      this.statements.cols.push({ dataField: 'paymentNo', caption: this.$t('enquiriesCustomerDetails.invoiceNo') });
      this.statements.cols.push({ dataField: 'closingBalance', caption: this.$t('enquiriesCustomerDetails.balance') });
      this.statements.cols.push({ dataField: 'payBy', caption: this.$t('enquiriesCustomerDetails.payBy'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.statements.cols.push({ dataField: 'emailSent', caption: this.$t('enquiriesCustomerDetails.emailSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.statements.cols.push({ dataField: 'smsSent', caption: this.$t('enquiriesCustomerDetails.smsSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
    },

    fillOperations(isLoading = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.operations.pageingOption
      }
      if (isLoading)
        this.operations.isLoading = true;

      axios.post('/Enquiries/getCustomerOperations', parameters)
        .then(response => {
          if (response.status == 200) {
            this.operations.data = response.data.items;

            this.operations.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.operations.isLoading = false);
    },

    fillDetailsChanges(isLoading = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.detailchanges.pageingOption
      }

      if (isLoading)
        this.detailchanges.isLoading = true;

      axios.post('/Enquiries/getCustomerDetailsChanges', parameters)
        .then(response => {
          if (response.status == 200) {
            this.detailchanges.data = response.data.items;

            this.detailchanges.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.detailchanges.isLoading = false);
    },

    fillStatements(isLoading = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.statements.pageingOption
      }

      if (isLoading)
        this.statements.isLoading = true;

      axios.post('/Enquiries/getCustomerStatements', parameters)
        .then(response => {
          if (response.status == 200) {
            this.statements.data = response.data.items;

            this.statements.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.statements.isLoading = false);
    },


  }
}

